<template>
  <div id="active-plans">
    <PageTitle title="Farm For Me" backLink="/farms" />
    <b-container class="pb-5">
      <b-row align-v="stretch">
        <b-col cols="12">
          <b-tabs v-model="activeTab">
            <b-tab title="Offers">
              <Offers @setActiveTab="activeTab = 1" />
            </b-tab>
            <b-tab title="My Farms">
              <ActivePlans @setInvestTab="activeTab = 0" v-if="activeTab == 1" />
            </b-tab>
            <b-tab title="Pending">
              <PendingPlans
                @setInvestTab="activeTab = 0"
                v-if="activeTab == 2"
              />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>

    <InvestModal />
  </div>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import PageTitle from "@/components/ui/PageTitle";
import Offers from "./components/offers";
import ActivePlans from "./components/ActivePlan";
import PendingPlans from "./components/PendingPlan";

export default {
  data() {
    return {
      investments: [],
      activeInvestment: {},
      LuxonDateTime: LuxonDateTime,
      activeTab: 0,
    };
  },
  async created() {
    var hash = location.hash.substr(1);
    switch (hash) {
      case "":
        this.activeTab = 0;
        break;
      case "active-plans":
        this.activeTab = 1;
        break;
      case "pending":
        this.activeTab = 2;
        break;
      default:
    }
  },

  components: {
    PageTitle,
    ActivePlans,
    PendingPlans,
    Offers,
  },
};
</script>

<style lang="scss">
.investment-blocks {
  transition: all 0.25s ease;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
}

.invest-btn {
  transition: all 0.25s ease;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

  &:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
}
</style>
